import SharedRiskTab from 'pages/mobile/Finance/shared/RiskTab';
import React from 'react';

import { useConfirmingOperationDetail } from '../context';

export interface RiskProps {
  requestId: string;
}

const Risk: React.FC<RiskProps> = () => {
  const { requestId } = useConfirmingOperationDetail();
  return <SharedRiskTab product="confirming" requestId={requestId} />;
};

export default Risk;
